
export default {
  head() {
    return this.$seoMeta.head(this, {
      siteName: this.$t('siteName'),
      siteDesc: this.$t('siteDesc')
    })
  }
}
